import { Award, Flame } from "lucide-react";

const NAMES = { 5: { en: "Bookworm", fr: "Rat de bibliothèque" }, 10: { en: "Super reader", fr: "Super lecteur" }, 25: { en: "Library champion", fr: "Champion de la bibliothèque" } };
const COLORS = { 5: "bg-amber-300", 10: "bg-sky-300", 25: "bg-fuchsia-300" };
export const badgeName = (n, lang) => NAMES[n]?.[lang === "fr" ? "fr" : "en"] || "";

// Library badges: 5, 10 and 25 texts read to the end with the timer (English + French together)
export default function LibraryBadges({ badges, streak, lang, compact = false }) {
  if (!badges) return null;
  const fr = lang === "fr";
  return (
    <div className={`flex flex-wrap items-center gap-2 ${compact ? "" : "mb-4"}`} data-testid="library-badges">
      {[5, 10, 25].map((n) => {
        const got = badges.earned.includes(n);
        return (
          <span key={n} data-testid={`library-badge-${n}${got ? "-earned" : ""}`}
            className={`inline-flex items-center gap-1.5 rounded-full border-2 px-3 py-1 text-xs font-bold ${got ? `${COLORS[n]} border-slate-900` : "bg-white border-dashed border-slate-500 text-slate-600"}`}>
            <Award size={14} /> {n} · {badgeName(n, lang)}
          </span>
        );
      })}
      {streak && (
        <span className="inline-flex items-center gap-1 rounded-full border-2 border-slate-900 bg-orange-200 px-3 py-1 text-xs font-bold" data-testid="library-streak">
          <Flame size={14} className="text-orange-600" /> {fr ? `Série : ${streak.current} jour(s)` : `Streak: ${streak.current} day(s)`}
          {streak.best > streak.current && <span className="font-normal">· {fr ? "record" : "best"} {streak.best}</span>}
        </span>
      )}
      <span className="text-xs font-semibold text-slate-600" data-testid="library-badges-progress">
        {badges.next ? (fr ? `${badges.done} texte(s) lu(s) · prochain badge à ${badges.next}` : `${badges.done} text(s) read · next badge at ${badges.next}`)
          : (fr ? `${badges.done} textes lus · tous les badges gagnés !` : `${badges.done} texts read · all badges earned!`)}
      </span>
    </div>
  );
}
